import Request from './baseRequest'

// "Mejoras sugeridas": the search auditor's suggestions for a project (admin-apis proxies them
// to search-backend /audit/...). Every call resolves to the response body.

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const authConfig = (extra = {}) => ({
  headers: {
    authorization: `Bearer ${getUserToken()}`
  },
  ...extra
})

const base = projectId => `${window.config.VUE_APP_BACKEND}/api/searches/application/${projectId}/audit`

const getSummary = projectId =>
  Request.get(`${base(projectId)}/summary`, authConfig()).then(res => res.data)

const getSuggestions = (projectId, status) =>
  Request.get(`${base(projectId)}/suggestions`, authConfig({ params: status ? { status } : {} })).then(res => res.data)

// action: apply | dismiss | revert
const updateSuggestion = (projectId, suggestionId, action, body = {}) =>
  Request.post(`${base(projectId)}/suggestions/${suggestionId}/${action}`, body, authConfig()).then(res => res.data)

const getDemandGaps = projectId =>
  Request.get(`${base(projectId)}/demand-gaps`, authConfig()).then(res => res.data)

// Run log ("Qué revisó el auditor"): the runs of the project, and every query one run judged
const getRuns = projectId =>
  Request.get(`${base(projectId)}/runs`, authConfig()).then(res => res.data)

const getRun = (projectId, date, tag) =>
  Request.get(`${base(projectId)}/runs/${date}`, authConfig({ params: { tag } })).then(res => res.data)

export default {
  getSummary,
  getRuns,
  getRun,
  getSuggestions,
  updateSuggestion,
  getDemandGaps
}
